<template>
  <form action="https://api.proxyscrape.com/webproxy.php" method="POST">
    <input
      placeholder="Put a URL or search query here to start browsing"
      type="text"
      class="form-control"
      name="url"
    />

    <button type="submit" class="btn send-btn btn-blue">
      GO
      <img src="@/assets/img/svg/right-arrow-white.svg" alt="" class="btn-img" />
    </button>
  </form>
</template>

<script setup lang="ts"></script>

<style scoped>
.form-control {
  margin-top: 15px;
  height: 51px;
  width: calc(100% - 122px);
  display: inline-block;
  border-radius: 0.25rem 0 0 0.25rem;
}
.send-btn {
  border-radius: 0 0.25rem 0.25rem 0;
  margin-top: 5px;
}
.btn-img {
  height: 12px;
  min-height: unset;
  min-width: unset;
  margin-left: 7px;
  margin-top: -2px;
}
</style>
